import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SimiChatService {
  private LOGIN_URL: string = 'https://simibot.edship.in/auth/login';
  private QUERY_URL: string = 'https://simibot.edship.in/api/nlp-query';
    private GetChartUrl: string = 'https://simibot.edship.in/api/visualize';

  

  private token: string | null = null;

  constructor(private http: HttpClient) { }


  loginToGetToken(data: { username: string; password: string }) {
    const body = data;

    return this.http.post<{ token: string }>(this.LOGIN_URL, body).subscribe((res) => {
      this.token = res.token;
     
    });
  }

  getToken(): string | null {
    return this.token;
  }

  sendQuery(body: any) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`
    });

    return this.http.post<any>(this.QUERY_URL, body, { headers });
  }

  getGraphData(body:any){
      const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`
    });

    return this.http.post<any>(this.GetChartUrl, body, { headers });
  }
}
